<div class="card">
  <ng-container *ngIf="isLoading; else fullLoaded" style="max-height: 200px">
    <div class="spinner-container my-2">
      <div class="spinner"></div>
      <div class="loading-text">Cargando</div>
    </div>
  </ng-container>
  <ng-template #fullLoaded>
    <div class="card-body fixed-min">
      <div class="container">
        <div class="row align-content-center">
          <div class="col-md-3 col-sm-12">
            <div class="row align-content-center">
              <span class="col-4 form-label title-blue-bimbo-cap">ID:</span>
              <span class="col form-label text-center">{{
                eventData?.idPlaneacionCurso
              }}</span>
            </div>
          </div>

          <div class="col-md-9 col-sm-12">
            <div class="row"></div>
            <span class="col-3 form-label title-blue-bimbo-cap">Nombre:</span>
            <span class="col form-label text-center">{{
              (eventData?.nombre)!.length > 30
                ? (eventData?.nombre | slice: 0 : 60) + "..."
                : eventData?.nombre
            }}</span>
          </div>
        </div>
      </div>
      <div class="container">
        <div class="row align-content-center">
          <div class="col-md-6">
            <div class="row align-content-center">
              <span class="col-3 form-label title-blue-bimbo-cap"
                >Escuela:</span
              >
              <span class="col form-label">{{
                eventData?.escuela?.nombre
              }}</span>
            </div>
          </div>
          <div class="col-md-6">
            <div class="row"></div>
            <span class="col-3 form-label title-blue-bimbo-cap">Academia:</span>
            <span class="col form-label">{{
              eventData?.academia?.nombre
            }}</span>
          </div>
        </div>
      </div>
      <hr class="my-1" />
      <div class="container">
        <div class="row gx-1">
          <div class="col-lg-4 col-md-12 align-items-center">
            <div class="row">
              <span class="col-6 form-label title-blue-bimbo-cap"
                >Horas por Sesion:</span
              >
              <span class="col form-label"
                >{{ eventData?.horasSesion }} hrs.</span
              >
            </div>
          </div>
          <div class="col-lg-4 col-md-6">
            <div class="row">
              <span class="col-6 form-label title-blue-bimbo-cap"
                >Número de Sesiones:</span
              >
              <span class="col form-label"
                >{{
                  +eventData?.numeroDeSesiones!
                    | pluralize: "sesión" : "sesiones"
                }}
              </span>
            </div>
          </div>
          <div class="col-lg-4 col-md-6">
            <div class="row">
              <span class="col-6 form-label title-blue-bimbo-cap text-wrap"
                >Colaboradores por sesion:</span
              >
              <span class="col form-label">{{
                eventData?.colaboradoresPorSesion
              }}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="container">
        <div class="row gx-1">
          <div class="col-lg-4 col-md-12 align-items-center">
            <div class="row">
              <span class="col-6 form-label title-blue-bimbo-cap"
                >Organización:</span
              >
              <span class="col form-label">{{
                eventData?.organizacion?.nombre
              }}</span>
            </div>
          </div>
          <div class="col-lg-4 col-md-6">
            <div class="row">
              <span class="col-6 form-label title-blue-bimbo-cap">Sede:</span>
              <span class="col form-label">{{ eventData?.sede?.nombre }}</span>
            </div>
          </div>

          <div class="col-lg-4 col-md-6">
            <div class="row">
              <span class="col-6 form-label title-blue-bimbo-cap text-wrap"
                >Region:</span
              >
              <span class="col form-label">{{
                eventData?.region?.nombre
              }}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="container">
        <div class="row align-content-center">
          <div class="col-md-6">
            <div class="row align-content-center">
              <span class="col-3 form-label title-blue-bimbo-cap">Mes:</span>
              <span class="col form-label">{{
                eventData?.mes?.descripcion
              }}</span>
            </div>
          </div>
          <div class="col-md-6">
            <div class="row"></div>
            <span class="col-3 form-label title-blue-bimbo-cap">Area:</span>
            <span class="col form-label">{{ eventData?.area?.nombre }}</span>
          </div>
        </div>
      </div>
    </div>
  </ng-template>
</div>
